import {dhx4} from '../../global/dhx4OrDhx';
import  dhtmlXLayoutObject from './dhtmlXLayoutObject';

var dhtmlXLayoutSepObject = (function () {
    function dhtmlXLayoutSepObject(e, a) {
        var c = this;
        this.conf = {
            mode: e,
            idx: a,
            blocked: false,
            locked: false,
            btn_left: (dhx4.isIE6 || dhx4.isIE7 || dhx4.isIE8) &&
                typeof window.addEventListener == "undefined"
                ? 1
                : 0
        };
        if (dhx4.isIE &&
            navigator.userAgent.indexOf("MSIE 7.0") >= 0 &&
            navigator.userAgent.indexOf("Trident") >= 0) {
            this.conf.btn_left = 1;
        }
        this.sep = document.createElement("DIV");
        this.sep.className = "dhxlayout_sep";
        if (dhx4.isIE == true) {
            this.sep.onselectstart = function () {
                return false;
            };
        }
        this.sep.className = "dhxlayout_sep dhxlayout_sep_resize_" + this.conf.mode;
        this._setSize = function (g, n, l, m) {
            this.sep.style.left = g + "px";
            this.sep.style.top = n + "px";
            this.sep.style.width = Math.max(l, 0) + "px";
            this.sep.style.height = Math.max(m, 0) + "px";
        };
        this._lockSep = function (g) {
            this.conf.locked = g == true;
            this._blockSep();
        };
        this._setWH = function (g) {
            var h = this._getLayout();
            h.conf.sw = g == null ? h._detectSW() : Math.max(parseInt(g) || -1, -1);
            h._getMainInst().setSizes();
            h = null;
        };
        this._blockSep = function () {
            var g = this._getLayout();
            var h = g.cdata.a.conf.collapsed || g.cdata.b.conf.collapsed || this.conf.locked;
            g = null;
            if (this.conf.blocked == h) {
                return;
            }
            this.sep.className =
                "dhxlayout_sep" + (h ? "" : " dhxlayout_sep_resize_" + this.conf.mode);
            this.conf.blocked = h;
        };
        this._beforeResize = function (h) {
            if (this.conf.blocked) {
                return;
            }
            if (this.conf.resize != null && this.conf.resize.active == true) {
                return;
            }
            var m = null, l = null;
            if (h.type == dhx4.dnd.evs.start) {
                this.sep.className += " dhxlayout_sep_resize_actv";
                m = h.pageX || h.touches[0].pageX;
                l = h.pageY || h.touches[0].pageY;
            }
            else {
                if (h.button !== this.conf.btn_left) {
                    return;
                }
                m = h.clientX;
                l = h.clientY;
            }
            if (dhx4.dnd.p_en == true) {
                dhx4.dnd._touchOff();
            }
            var g = this._getLayout();
            this.conf.resize = {
                sx: m,
                sy: l,
                tx: h.layerX,
                ty: h.layerY,
                sep_x: parseInt(this.sep.style.left),
                sep_y: parseInt(this.sep.style.top),
                min_wa: g.cdata.a._getAvailWidth("a"),
                min_wb: g.cdata.b._getAvailWidth("b"),
                min_ha: g.cdata.a._getAvailHeight("a"),
                min_hb: g.cdata.b._getAvailHeight("b")
            };
            this.conf.resize.nx = this.conf.resize.sep_x;
            this.conf.resize.ny = this.conf.resize.sep_y;
            if (typeof window.addEventListener == "function") {
                window.addEventListener("mousemove", this._doOnMouseMove, false);
                window.addEventListener("mouseup", this._doOnMouseUp, false);
                window.addEventListener(dhx4.dnd.evs.move, this._doOnMouseMove, false);
                window.addEventListener(dhx4.dnd.evs.end, this._doOnMouseUp, false);
            }
            else {
                document.body.attachEvent("onmousemove", this._doOnMouseMove);
                document.body.attachEvent("onmouseup", this._doOnMouseUp);
            }
            g = null;
        };
        this._onResize = function (l) {
            if (!this.conf.resize.active) {
                this._initResizeArea();
                this.conf.resize.active = true;
            }
            var h = null;
            if (this.conf.mode == "v") {
                var g = l.type == "mousemove" ? l.clientX : l.pageX || l.touches[0].pageX;
                h = this.conf.resize.sx - g;
                this.conf.resize.nx = this.conf.resize.sep_x - h;
                if (this.conf.resize.nx >
                    this.conf.resize.sep_x + this.conf.resize.min_wb) {
                    this.conf.resize.nx = this.conf.resize.sep_x + this.conf.resize.min_wb;
                }
                else {
                    if (this.conf.resize.nx <
                        this.conf.resize.sep_x - this.conf.resize.min_wa) {
                        this.conf.resize.nx =
                            this.conf.resize.sep_x - this.conf.resize.min_wa;
                    }
                }
                this.r_sep.style.left = this.conf.resize.nx + "px";
            }
            else {
                var m = l.type == "mousemove" ? l.clientY : l.pageY || l.touches[0].pageY;
                h = this.conf.resize.sy - m;
                this.conf.resize.ny = this.conf.resize.sep_y - h;
                if (this.conf.resize.ny >
                    this.conf.resize.sep_y + this.conf.resize.min_hb) {
                    this.conf.resize.ny = this.conf.resize.sep_y + this.conf.resize.min_hb;
                }
                else {
                    if (this.conf.resize.ny <
                        this.conf.resize.sep_y - this.conf.resize.min_ha) {
                        this.conf.resize.ny =
                            this.conf.resize.sep_y - this.conf.resize.min_ha;
                    }
                }
                this.r_sep.style.top = this.conf.resize.ny + "px";
            }
        };
        this._afterResize = function (r) {
            if (typeof window.addEventListener == "function") {
                window.removeEventListener("mousemove", this._doOnMouseMove, false);
                window.removeEventListener("mouseup", this._doOnMouseUp, false);
                window.removeEventListener(dhx4.dnd.evs.move, this._doOnMouseMove, false);
                window.removeEventListener(dhx4.dnd.evs.end, this._doOnMouseUp, false);
            }
            else {
                document.body.detachEvent("onmousemove", this._doOnMouseMove);
                document.body.detachEvent("onmouseup", this._doOnMouseUp);
            }
            if (!this.conf.resize.active) {
                this.conf.resize = null;
                return;
            }
            if (r.type == dhx4.dnd.evs.end) {
                this.sep.className = this.sep.className.replace(/\s{0,}dhxlayout_sep_resize_actv/gi, "");
            }
            else {
                if (r.button !== this.conf.btn_left) {
                    return;
                }
            }
            var m = this._getLayout();
            var h = m._getMainInst();
            var n = h.checkEvent("onPanelResizeFinish") == true ? {} : false;
            if (n !== false) {
                h.forEachItem(function (u) {
                    n[u.conf.name] = { w: u.conf.size.w, h: u.conf.size.h };
                    u = null;
                });
            }
            var l = this.conf.resize.nx - this.conf.resize.sep_x;
            var g = this.conf.resize.ny - this.conf.resize.sep_y;
            m.cdata.a._setSize(m.cdata.a.conf.size.x, m.cdata.a.conf.size.y, m.cdata.a.conf.size.w + l, m.cdata.a.conf.size.h + g, "a");
            m.cdata.b._setSize(m.cdata.b.conf.size.x + l, m.cdata.b.conf.size.y + g, m.cdata.b.conf.size.w - l, m.cdata.b.conf.size.h - g, "b");
            this._setSize(parseInt(this.r_sep.style.left), parseInt(this.r_sep.style.top), parseInt(this.r_sep.style.width), parseInt(this.r_sep.style.height));
            if (dhx4.isIE) {
                var s = this;
                window.setTimeout(function () {
                    s._removeResizeArea();
                    s = null;
                }, 1);
            }
            else {
                this._removeResizeArea();
            }
            if (n !== false) {
                var o = [];
                h.forEachItem(function (u) {
                    var v = n[u.conf.name];
                    if (!(v.w == u.conf.size.w && v.h == u.conf.size.h)) {
                        o.push(u.conf.name);
                    }
                    u = null;
                });
                h._callMainEvent("onPanelResizeFinish", [o]);
            }
            h = m = null;
            this.conf.resize.active = false;
            this.conf.resize = null;
            if (dhx4.dnd.p_en == true) {
                dhx4.dnd._touchOn();
            }
        };
        this._initResizeArea = function () {
            if (this.r_sep == null) {
                this.r_sep = document.createElement("DIV");
                this.r_sep.className = "dhxlayout_resize_sep";
                this.r_sep.style.left = this.sep.style.left;
                this.r_sep.style.top = this.sep.style.top;
                this.r_sep.style.width = this.sep.style.width;
                this.r_sep.style.height = this.sep.style.height;
                this.sep.parentNode.appendChild(this.r_sep);
                if (dhx4.isIE) {
                    this.r_sep.onselectstart = function () {
                        return false;
                    };
                }
            }
            if (this.r_area == null) {
                this.r_area = document.createElement("DIV");
                this.r_area.className = "dhxlayout_resize_area";
                this.sep.parentNode.appendChild(this.r_area);
                if (dhx4.isIE) {
                    this.r_area.onselectstart = function () {
                        return false;
                    };
                }
                var g = null, n = null, l = null, m = null;
                if (this.conf.mode == "v") {
                    g = parseInt(this.r_sep.style.left) - this.conf.resize.min_wa;
                    n = parseInt(this.r_sep.style.top);
                    l =
                        this.conf.resize.min_wa +
                            this.conf.resize.min_wb +
                            parseInt(this.r_sep.style.width);
                    m = parseInt(this.r_sep.style.height);
                }
                else {
                    g = parseInt(this.r_sep.style.left);
                    n = parseInt(this.r_sep.style.top) - this.conf.resize.min_ha;
                    l = parseInt(this.r_sep.style.width);
                    m =
                        this.conf.resize.min_ha +
                            this.conf.resize.min_hb +
                            parseInt(this.r_sep.style.height);
                }
                this.r_area.style.left = g + "px";
                this.r_area.style.top = n + "px";
                if (!dhtmlXLayoutObject.prototype._confGlob.reszieCover) {
                    dhtmlXLayoutObject.prototype._confGlob.reszieCover = {};
                    this.r_area.style.width = l + "px";
                    this.r_area.style.height = m + "px";
                    dhtmlXLayoutObject.prototype._confGlob.reszieCover.w =
                        parseInt(this.r_area.style.width) - this.r_area.offsetWidth;
                    dhtmlXLayoutObject.prototype._confGlob.reszieCover.h =
                        parseInt(this.r_area.style.height) - this.r_area.offsetHeight;
                }
                this.r_area.style.width =
                    l + dhtmlXLayoutObject.prototype._confGlob.reszieCover.w + "px";
                this.r_area.style.height =
                    m + dhtmlXLayoutObject.prototype._confGlob.reszieCover.h + "px";
            }
            document.body.className += " dhxlayout_resize_" + this.conf.mode;
        };
        this._removeResizeArea = function () {
            this.r_sep.onselectstart = null;
            this.r_sep.parentNode.removeChild(this.r_sep);
            this.r_sep = null;
            this.r_area.onselectstart = null;
            this.r_area.parentNode.removeChild(this.r_area);
            this.r_area = null;
            document.body.className = String(document.body.className).replace(/\s{0,}dhxlayout_resize_[vh]/gi, "");
        };
        this._doOnMouseDown = function (g) {
            g = g || event;
            if (g.preventDefault) {
                g.preventDefault();
            }
            else {
                g.cancelBubble = true;
            }
            c._beforeResize(g);
        };
        this._doOnBodyMouseDown = function (g) {
            g = g || event;
            if (c.conf.resize == null) {
                return;
            }
            if (c.conf.resize.active == true && g.button !== c.conf.btn_left) {
                if (g.preventDefault) {
                    g.preventDefault();
                }
                g.returnValue = false;
                g.cancelBubble = true;
                return false;
            }
        };
        this._doOnMouseMove = function (g) {
            g = g || event;
            if (g.preventDefault) {
                g.preventDefault();
            }
            else {
                g.cancelBubble = true;
            }
            c._onResize(g);
        };
        this._doOnMouseUp = function (g) {
            g = g || event;
            if (g.type == "mouseup" && g.button !== c.conf.btn_left) {
                return;
            }
            c._afterResize(g);
        };
        if (typeof window.addEventListener == "function") {
            this.sep.addEventListener("mousedown", this._doOnMouseDown, false);
            this.sep.addEventListener(dhx4.dnd.evs.start, this._doOnMouseDown, false);
            document.body.addEventListener("mousedown", this._doOnBodyMouseDown, false);
            document.body.addEventListener("contextmenu", this._doOnBodyMouseDown, false);
        }
        else {
            this.sep.attachEvent("onmousedown", this._doOnMouseDown);
            document.body.attachEvent("onmousedown", this._doOnBodyMouseDown);
            document.body.attachEvent("oncontextmenu", this._doOnBodyMouseDown);
        }
        this._unload = function () {
            if (typeof window.addEventListener == "function") {
                this.sep.removeEventListener("mousedown", this._doOnMouseDown, false);
                this.sep.removeEventListener(dhx4.dnd.evs.start, this._doOnMouseDown, false);
                document.body.removeEventListener("mousedown", this._doOnBodyMouseDown, false);
                document.body.removeEventListener("contextmenu", this._doOnBodyMouseDown, false);
            }
            else {
                this.sep.detachEvent("onmousedown", this._doOnMouseDown);
                document.body.detachEvent("onmousedown", this._doOnBodyMouseDown);
                document.body.detachEvent("oncontextmenu", this._doOnBodyMouseDown);
            }
            if (dhx4.isIE == true) {
                this.sep.onselectstart = null;
            }
            this.sep.parentNode.removeChild(this.sep);
            this.sep = null;
            for (var g in this) {
                this[g] = null;
            }
            c = null;
        };
        return this;
    }
    return dhtmlXLayoutSepObject;
})();

export default dhtmlXLayoutSepObject;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXLayoutObject/dhtmlXLayoutSepObject.js